import React, { useEffect, useState } from "react";
import Select from "react-select";

/**
 * Componente de selección de empresa con soporte para modo oscuro dinámico
 */
const SelectEmpresa = ({
  options = [],
  onChange,
  value,
  isDisabled = false,
}) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Detectar clase 'dark-mode' en body o .app
  const checkDarkMode = () =>
    document.body.classList.contains("dark-mode") ||
    document.querySelector(".app")?.classList.contains("dark-mode");

  useEffect(() => {
    setIsDarkMode(checkDarkMode());

    const targetNode = document.querySelector(".app") || document.body;
    const observer = new MutationObserver(() => setIsDarkMode(checkDarkMode()));

    observer.observe(targetNode, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 38,
      backgroundColor: isDarkMode ? "#1e1e2f" : "#fff",
      borderColor: state.isFocused
        ? "#6c63ff"
        : isDarkMode
        ? "#444"
        : "#ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(108, 99, 255, 0.25)"
        : "none",
      color: isDarkMode ? "#fff" : "#000",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: isDarkMode ? "#1e1e2f" : "#fff",
      color: isDarkMode ? "#fff" : "#000",
      zIndex: 9999, // ✅ Este z-index asegura que se muestre por encima del botón
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // ✅ Compatible con menuPortalTarget
    }),
    singleValue: (provided) => ({
      ...provided,
      color: isDarkMode ? "#fff" : "#000",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#6c63ff"
        : state.isFocused
        ? isDarkMode
          ? "#2c2c3e"
          : "#f0f0f0"
        : isDarkMode
        ? "#1e1e2f"
        : "#fff",
      color: isDarkMode ? "#fff" : "#000",
      cursor: "pointer",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: isDarkMode ? "#aaa" : "#888",
    }),
    input: (provided) => ({
      ...provided,
      color: isDarkMode ? "#fff" : "#000",
    }),
  };

  return (
    <Select
      styles={customStyles}
      placeholder="Seleccione una empresa..."
      isClearable
      isDisabled={isDisabled}
      menuPortalTarget={document.body} // Clave para que el menú se renderice fuera del flujo y respete el z-index
      options={options.map((c) => ({
        value: c.companyId,
        label: `${c.name} `,
      }))}
      value={
        value
          ? {
              value: value,
              label: options.find((c) => c.companyId === value)?.name,
            }
          : null
      }
      onChange={(selectedOption) => onChange(selectedOption?.value || "")}
    />
  );
};

export default SelectEmpresa;
